import Facebook from './channels/Facebook';
import Instagram from './channels/Instagram';
import Website from './channels/Website';
import Twitter from './channels/Twitter';
import Api from './channels/Api';
import Email from './channels/Email';
import Sms from './channels/Sms';
import Whatsapp from './channels/Whatsapp';
import Line from './channels/Line';
import Telegram from './channels/Telegram';
import Voll360 from './channels/Voll360';
import Wetalkie from "./channels/Wetalkie";
import Omne from './channels/Omne';
import Multimedia from './channels/Multimedia';
import Zendesk from './channels/Zendesk';
import Infobip from './channels/Infobip';

const channelViewList = {
  facebook: Facebook,
  instagram: Instagram,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  voll360: Voll360,
  wetalkie: Wetalkie,
  omne: Omne,
  multimedia: Multimedia,
  zendesk: Zendesk,
  infobip: Infobip,
};

export default {
  create() {
    return {
      props: {
        channel_name: {
          type: String,
          required: true,
        },
      },
      name: 'new-channel-view',
      render(h) {
        return h(channelViewList[this.channel_name] || null);
      },
    };
  },
};
